import React from 'react'
import { Input, InputNumber, Select, DatePicker, Checkbox, Space, Button } from 'antd'
import locale from 'antd/es/date-picker/locale/fr_FR';
import moment from 'moment';
import 'moment/locale/fr';
import PropTypes from 'prop-types';
import { SearchOutlined } from '@ant-design/icons';
import FilterEnum from './FilterEnum';
import dayjs from 'dayjs';


const { Option } = Select

export class DateFilter extends React.Component {
  constructor(props) {
    super(props);
    this.DisplaydateFormat = 'DD/MM/YYYY';
    this.momentformat = 'YYYY-MM-DD'
    if (this.props.showTime && this.props.showTime === true) {
      this.DisplaydateFormat = 'DD/MM/YYYY HH:mm:ss';
      this.momentformat = 'YYYY-MM-DDTHH:mm:ss'
    }

    this.state = {
      ope: 'Between',
      value1: this.props.value1,
      value2: this.props.value2,
    }
  }

  handleChange = (value) => {
    const {selectedKeys}= this.props
    const curstat = {
      ope:selectedKeys.length===0 ||selectedKeys[0].ope===undefined?'Between':value,
      value1:selectedKeys.length===0 ||selectedKeys[0].value1===undefined? null:selectedKeys[0].value1,
      value2:selectedKeys.length===0 ||selectedKeys[0].value2===undefined? null :selectedKeys[0].value2
    }


    this.props.onChange(curstat);

  }

  handleChangeValue1 = (value,text) => {
     const {selectedKeys}= this.props

    const curstat = {
      ope:selectedKeys.length===0 ||selectedKeys[0].ope===undefined?'Between':selectedKeys[0].ope,
      value1:selectedKeys.length===0 ||selectedKeys[0].value1===undefined? null:selectedKeys[0].value1,
      value2:selectedKeys.length===0 ||selectedKeys[0].value2===undefined? null :selectedKeys[0].value2
    }

    if (value === null) {
      curstat.value1 = null
    } else {
      curstat.value1 = value.format(this.momentformat)

    }

   // this.setState(curstat)
    this.props.onChange(curstat);
  }

  handleChangeValue2 = (value,text) => {
    const {selectedKeys}= this.props
    const curstat = {
      ope:selectedKeys.length===0 ||selectedKeys[0].ope===undefined?'Between':selectedKeys[0].ope,
      value1:selectedKeys.length===0 ||selectedKeys[0].value1===undefined? null:selectedKeys[0].value1,
      value2:selectedKeys.length===0 ||selectedKeys[0].value2===undefined? null :selectedKeys[0].value2
    }

    if (value === null) {
      curstat.value2 = null
    } else {
      curstat.value2 = value.format(this.momentformat);
    }

    //this.setState(curstat)
    this.props.onChange(curstat);
  }

  render() {
    const {selectedKeys}= this.props

    let ope
    let dpvalue1
    let dpvalue2
    if (selectedKeys.length===0 ||selectedKeys[0].ope===undefined) {ope='Between'} else {ope=selectedKeys[0].ope}
    if (selectedKeys.length===0 ||selectedKeys[0].value2===undefined) {dpvalue2= null} else {dpvalue2=selectedKeys[0].value2}
    if (selectedKeys.length===0 ||selectedKeys[0].value1===undefined)    {dpvalue1= null} else {dpvalue1=selectedKeys[0].value1}
    

    const showValue2 = ope === 'Between'
    const showValue1 = ope !== ''

    const DisplaydateFormat = this.DisplaydateFormat

 
    let dpValue1 = (dpvalue1 === null) ? null : moment(dpvalue1, this.momentformat)
    let dpValue2 = (dpvalue2 === null) ? null : moment(dpvalue2, this.momentformat)


    return (
      <div>
        <Select value={ope} style={{ width: 120 }} onChange={this.handleChange} >
          <Option value=""></Option>
          <Option value="eq">=</Option>

          <Option value="greatereq">{'>='}</Option>
          <Option value="greater">{'>'}</Option>
          <Option value="LesserEq">{'<='}</Option>
          <Option value="Lesser">{'<'}</Option>
          <Option value="Between">entre</Option>
        </Select>
        {
          showValue1 ? (

            <DatePicker showTime={this.props.showTime}
            value={dpValue1===null?null:dayjs(dpValue1.format(DisplaydateFormat), DisplaydateFormat)} format={DisplaydateFormat}
             locale={locale} 
              onChange={this.handleChangeValue1}
              onOk={this.handleChangeValue1}
         
            />
          ) : null
        }

        {
          showValue2 ? (
            <div style={{ display: 'table' }}>

              <div style={{ width: 120, display: 'table-cell' }}>et</div>
              <div style={{ display: 'table-cell' }}>
                <DatePicker showTime={this.props.showTime}
                      locale={locale} 
                  value={dpValue2===null?null:dayjs(dpValue2.format(DisplaydateFormat), DisplaydateFormat)} format={DisplaydateFormat}
                  onChange={this.handleChangeValue2}
                  onOk={this.handleChangeValue2}
                  
                />
              </div>

            </div>
          ) : null
        }

      </div>
    )
  }
}

export class NumberFilter extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      ope: 'eq',
      value1: null,
      value2: null,
    }
  }

  handleChange = (value) => {
    const curstat = this.state;
    curstat.ope = value;

    this.setState(curstat)
    this.props.onChange(curstat);

  }

  handleChangeValue1 = (value) => {
    const curstat = this.state;

    curstat.value1 = value

    this.setState(curstat)
    this.props.onChange(curstat);
  }

  handleChangeValue2 = (value) => {
    const curstat = this.state;
    curstat.value2 = value

    this.setState(curstat)
    this.props.onChange(curstat);
  }

  render() {
    const showValue2 = this.state.ope === 'Between'
    const showValue1 = this.state.ope !== ''

    return (
      <div>
        <Select defaultValue='eq' style={{ width: 120 }} onChange={this.handleChange} >
          <Option value=""></Option>
          <Option value="eq">=</Option>          
          <Option value="greatereq">{'>='}</Option>
          <Option value="greater">{'>'}</Option>
          <Option value="LesserEq">{'<='}</Option>
          <Option value="Lesser">{'<'}</Option>
          <Option value="Between">entre</Option>
        </Select>
        {
          showValue1 ? (

            <InputNumber
              onChange={this.handleChangeValue1}
              onOk={this.handleChangeValue1}
              value={this.state.value1}
            />
          ) : null
        }

        {
          showValue2 ? (
            <div style={{ display: 'table' }}>

              <div style={{ width: 120, display: 'table-cell' }}>et</div>
              <div style={{ display: 'table-cell' }}>
                <InputNumber
                  onChange={this.handleChangeValue2}
                  onOk={this.handleChangeValue2}
                  value={this.state.value2}
                />
              </div>

            </div>
          ) : null
        }

      </div>
    )
  }
}

export class TextFilter extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      ope: 'eq',
      value1: null,
      value2: null,
    }
  }

  handleChange = (value) => {
    const curstat = this.state;
    curstat.ope = value;

    this.setState(curstat)
    this.props.onChange(curstat);

  }

  handleChangeValue1 = (value) => {
    const curstat = this.state;

    curstat.value1 = value.target.value

    this.setState(curstat)
    this.props.onChange(curstat);
  }

  handleChangeValue2 = (value) => {
    const curstat = this.state;
    curstat.value2 = value.target.value

    this.setState(curstat)
    this.props.onChange(curstat);
  }

  render() {
    const showValue2 = this.state.ope === 'Between'
    const showValue1 = this.state.ope !== ''

    return (
      <div>
        <Select defaultValue='eq' style={{ width: 120 }} onChange={this.handleChange} >
          <Option value=""></Option>
          <Option value="eq">=</Option>
          <Option value="contains">Contient</Option>
          <Option value="startWith">Commence par</Option>
          <Option value="endWith">Fini par</Option>
        </Select>
        {
          showValue1 ? (

            <Input
              onChange={this.handleChangeValue1}
              value={this.state.value1}
            />
          ) : null
        }

        {
          showValue2 ? (
            <div style={{ display: 'table' }}>

              <div style={{ width: 120, display: 'table-cell' }}>et</div>
              <div style={{ display: 'table-cell' }}>
                <Input
                  onChange={this.handleChangeValue2}
                  onOk={this.handleChangeValue2}
                  value={this.state.value2}
                />
              </div>

            </div>
          ) : null
        }

      </div>
    )
  }
}

export class FilterCheckBox extends React.Component {
  state = {
    checked: false,
    indeterminate: false
  }

  componentDidMount() {
    let checked = undefined
    let indeterminate = undefined
    if (this.props.value === 1) {
      checked = true
      indeterminate = false
    } else if (this.props.value === 0) {
      checked = false
      indeterminate = false
    } else {
      checked = false
      indeterminate = true
    }
    this.setState({
      checked: checked,
      indeterminate: indeterminate
    })
  }

  componentDidUpdate(prevprops) {
    if (prevprops.value !== this.props.value) {
      let checked = undefined
      let indeterminate = undefined
      if (this.props.value === 1) {
        checked = true
        indeterminate = false
      } else if (this.props.value === 0) {
        checked = false
        indeterminate = false
      } else {
        checked = false
        indeterminate = true
      }
      this.setState({
        checked: checked,
        indeterminate: indeterminate
      })
    }

  }

  onChange = e => {
    let value = undefined
    let { checked, indeterminate } = this.state
    if (!checked && indeterminate) {
      checked = false
      indeterminate = false
      value = 0
    } else if (checked && !indeterminate) {
      checked = false
      indeterminate = true
      value = -1
    } else if (!checked && !indeterminate) {
      checked = true
      indeterminate = false
      value = 1
    }
    this.setState({
      checked: checked,
      indeterminate: indeterminate
    })
    this.props.onChange(e.target.name, value)
  }

  render() {
    const { checked, indeterminate } = this.state
    return (
      <Checkbox
        name={this.props.name}
        indeterminate={indeterminate}
        onChange={this.onChange}
        checked={checked}
      />
    )
  }
}


export const FilterDateDropDown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8, width: 600, zIndex: 'auto' }}>
    <DateFilter
      selectedKeys={selectedKeys}
      showTime={false}
      onChange={value => {
        setSelectedKeys(value ? [value] : [])

      }}

    />

    <Space>
      <Button
        type="primary"
        onClick={() => {
          confirm()

        }}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90 }}
      >
        Chercher
      </Button>
      <Button onClick={() => {
        clearFilters()
      }}
        size="small" style={{ width: 90 }}>
        Supprimer
      </Button>

    </Space>
  </div>)


export const FilterNumberDropDown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8, width: 600, zIndex: 'auto' }}>
    <NumberFilter
      selectedKeys={selectedKeys}
      showTime={false}
      onChange={value => {
        setSelectedKeys(value ? [value] : [])

      }}

    />

    <Space>
      <Button
        type="primary"
        onClick={() => {
          confirm()

        }}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90 }}
      >
        Chercher
      </Button>
      <Button onClick={() => {
        clearFilters()
      }}
        size="small" style={{ width: 90 }}>
        Supprimer
      </Button>

    </Space>
  </div>)



export const FilterEnumDropDown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, datasource, id, libelle }) => (
  <div style={{ padding: 8, width: 600, zIndex: 'auto' }}>
    <FilterEnum
      datasource={datasource}
      selected={selectedKeys}
      onChange={(value) => { setSelectedKeys([...value]) }}
      style={{ marginBottom: 8, display: 'block' }}
      id={id}
      libelle={libelle}
    />

    <Space>
      <Button
        type="primary"
        onClick={() => {
          confirm()

        }}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90 }}
      >
        Chercher
      </Button>
      <Button onClick={() => {
        clearFilters()
      }}
        size="small" style={{ width: 90 }}>
        Supprimer
      </Button>

    </Space>
  </div>)

export const FilterTextDropDown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8, width: 600, zIndex: 'auto' }}>
    <Input
      value={selectedKeys[0]}
      onChange={(e) => {
        if (e.target.value!==undefined && e.target.value!=='')
         setSelectedKeys([e.target.value])
        else 
          clearFilters()
      }}
      style={{ marginBottom: 8, display: 'block' }}

    />

    <Space>
      <Button
        type="primary"
        onClick={() => {
          confirm()

        }}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90 }}
      >
        Chercher
      </Button>
      <Button onClick={() => {
        clearFilters()
      }}
        size="small" style={{ width: 90 }}>
        Supprimer
      </Button>

    </Space>
  </div>)


FilterTextDropDown.propTypes = {
  setSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.array,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func
}

FilterDateDropDown.propTypes = {
  setSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.array,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func
}

FilterNumberDropDown.propTypes = {
  setSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.array,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func
}


DateFilter.propTypes = {
  showTime: PropTypes.bool,
  onChange: PropTypes.func

};

NumberFilter.propTypes = {
  onChange: PropTypes.func

};

TextFilter.propTypes = {
  onChange: PropTypes.func
};

FilterCheckBox.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.number
};

FilterEnumDropDown.propTypes = 
{ 
  setSelectedKeys: PropTypes.func, 
  selectedKeys : PropTypes.array,
  confirm: PropTypes.func, 
  clearFilters: PropTypes.func, 
  datasource: PropTypes.string, 
  id: PropTypes.string, 
  libelle : PropTypes.string
}